import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { getOgImageUrl, getSiteUrl } from "./site";

/**
 * @param {object} props
 * @param {string} props.title - Titre de la page (suffixe « | Raguia » ajouté si absent)
 * @param {string} props.description - Meta description (≈ 150–160 caractères recommandés)
 * @param {boolean} [props.noIndex]
 * @param {Record<string, unknown> | Record<string, unknown>[]} [props.jsonLd] - Données structurées schema.org
 */
export function SeoHead({ title, description, noIndex, jsonLd }) {
  const { pathname } = useLocation();
  const siteUrl = getSiteUrl();
  const canonical = `${siteUrl}${pathname === "/" ? "" : pathname}`;
  const fullTitle = title.toLowerCase().includes("raguia") ? title : `${title} | Raguia`;
  const ogImage = getOgImageUrl();

  const jsonLdArray = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Raguia" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content="Raguia — assistant documentaire IA" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      <meta name="theme-color" content="#A43032" />
      <meta name="color-scheme" content="light" />
      <meta
        name="robots"
        content={noIndex ? "noindex, nofollow" : "index, follow, max-image-preview:large"}
      />

      {jsonLdArray.map((data, i) => (
        <script key={data["@type"] || i} type="application/ld+json">
          {JSON.stringify(data)}
        </script>
      ))}
    </Helmet>
  );
}
